export default {
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  MUX_ANALYTICS_KEY: "g390j6uqqi612ienbuk94q10h",
  APP_NAME: process.env.REACT_APP_NAME,
  CONFIG_NAME: process.env.REACT_APP_CONFIG_NAME, 
  CONFIG_URL_PREFIX: process.env.REACT_APP_CONFIG_URL_PREFIX,
  CONFIG_URL_POSTFIX: process.env.REACT_APP_CONFIG_URL_POSTFIX,
}